import type { OrganisationInterface } from '@/types'

import generalCn from '../OrganisationsSearch.module.scss'

type OrganisationBadgesPropsType = {
  organisation: OrganisationInterface
}

function OrganisationBadges({ organisation }: OrganisationBadgesPropsType) {
  return (
    <>
      <span
        className={generalCn.listItemType}
        data-legal={organisation.isLegal}
      >
        {organisation.isLegal ? 'Юр. лицо' : 'Физ. лицо'}
      </span>
      <span className={generalCn.listItemId} data-legal={organisation.isLegal}>
        <span className={generalCn.listItemIdLabel}>
          {organisation.vatNumber ? 'УНП' : 'Код'}
        </span>
        <span className={generalCn.listItemIdValue}>
          {organisation.vatNumber || organisation.code}
        </span>
      </span>
    </>
  )
}

export default OrganisationBadges
